export var ExperimentVesselType;
(function (ExperimentVesselType) {
    ExperimentVesselType[ExperimentVesselType["OTHER"] = 0] = "OTHER";
})(ExperimentVesselType || (ExperimentVesselType = {}));
